if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      // Elements
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.shippingMessage = this.querySelector('.js-shipping-message');
      this.customUrgencyLine = this.querySelector('.js-custom-urgency-line');

      // Data
      this.variantInventory = this.getVariantInventory();
      this.freeShipThreshold = parseInt(this.dataset.freeShipThreshold || '9900', 10);
      this.hideFreeShip = (this.dataset.hideFreeShip ?? '').toString().trim().toLowerCase() === 'true';
      this.currentPriceCents = parseInt(this.dataset.initialPrice || '0', 10);

      // Bind to variant change
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Initial render
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity || '0', 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy,
        this.currentPriceCents
      );
    }

    getVariantInventory() {
      const dataEl = this.closest('.product-info')?.querySelector('.js-inventory-data');
      if (!dataEl) return [];
      try { return JSON.parse(dataEl.textContent); } catch (e) { return []; }
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const v = evt.detail.variant;
        const inventory = this.variantInventory.find((variant) => variant.id === v.id);
        if (inventory) {
          this.currentPriceCents = typeof v.price === 'number' ? v.price : this.currentPriceCents;
          this.updateInventory(inventory.inventory_quantity, inventory.available, inventory.inventory_policy, this.currentPriceCents);
        }
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy, priceCents = this.currentPriceCents) {
      let inventoryLevel;
      if (count <= 0) {
        inventoryLevel = (inventoryPolicy === 'continue') ? 'backordered' : (available ? 'in_stock' : 'none');
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      const onPdp = !!this.closest('.product-info');
      if (onPdp && inventoryLevel === 'backordered') {
        this.hidden = true;
        this.shippingMessage?.classList.remove('show');
        return;
      }

      // 1. COMBINED SHIPPING & URGENCY (The Dynamic Text)
      if (available === false || !this.shippingMessage) {
        this.shippingMessage?.classList.remove('show');
      } else {
        const now = new Date();
        const day = now.getDay();
        const hour = now.getHours();
        let shippingInfo = '';
        let scarcityText = '';

        // Scarcity highlight for 2 or below
        if (count > 0 && count <= 2) {
          scarcityText = `<strong>Order fast! Only ${count} left.</strong> `;
        }
        
        // NZ Shipping Windows
        if (day >= 1 && day <= 4) { //1 / 4 
          shippingInfo = hour < 15 ? ` Order by <strong>3pm</strong> and it <strong>ships today!</strong>` : `Ships <strong>tomorrow</strong> from our NZ warehouse!`; //today / tomorrow
        } else if (day === 5) {
          shippingInfo = hour < 15 ? `Order by <strong>3pm</strong> for <strong>same-day dispatch!</strong>` : `Ships <strong>Monday</strong> from our NZ warehouse!`; // same-day / Monday
        } else {
          shippingInfo = (day === 0) ? `Ships <strong>tomorrow</strong> from our NZ warehouse!` : `Ships <strong>Monday</strong> from our NZ warehouse!`; // tomorrow / Monday
        }

        this.shippingMessage.innerHTML = ` - ${scarcityText}${shippingInfo}`;
        this.shippingMessage.classList.add('show');
      }

      // 2. PILL LOGIC
      if (this.dataset.showNotice === 'always' || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')) || inventoryLevel === 'backordered') {
        this.hidden = false;
        if (this.inventoryNotice) {
          this.inventoryNotice.classList.remove('pill--free-ship');
          this.inventoryNotice.innerText = (inventoryLevel === 'backordered')
          ? (this.dataset.textNoStockBackordered || 'Pre-order').replace(/<[^>]*>/g, '').trim()
          : (available ? 'In stock' : 'Out of stock');
        }
      } else {
        this.hidden = true;
      }

      // 3. TARGET THE BUY BUTTON (From your HTML snippet)
      const buyBtn = this.closest('.product-info')?.querySelector('button[name="add"]');
      if (buyBtn) {
        if (count > 0 && count <= 2) {
          buyBtn.style.setProperty('background-color', '#d0021b', 'important'); // Urgency Red
          buyBtn.style.setProperty('border-color', '#d0021b', 'important');
        } else {
          buyBtn.style.backgroundColor = '';
          buyBtn.style.borderColor = '';
        }
      }

      // Remove the old extra line
      if (this.customUrgencyLine) this.customUrgencyLine.style.display = 'none';
    }
  }
  customElements.define('product-inventory', ProductInventory);
}